import React, { useContext, useEffect } from 'react'
import { observer } from 'mobx-react'
import { useNavigate } from 'react-router'
import { StoresContext } from '@App/contexts'
import Navigation from '@App/navigation'
import PublicSearchByWorkTab from '@Scenes/PublicSearchScene/PublicSearchByWorkTab'
import { bulkActionLabels, WorkMergeBulkActionType } from '@App/stores/search/work/work-merge-bulk-action-store'
import WorkMergeBulkAction from '@Scenes/RightsholderScene/WorkMerge/WorkMergeSearch/components/WorkMergeBulkAction'
import WorkMergePanel from '@Scenes/RightsholderScene/WorkMerge/WorkMergeSearch/components/WorkMergePanel'
import BulkActionLeavePageModal from '@Components/BulkAction/BulkActionLeavePageModal'
import { useBulkActionNavigation } from '@Components/BulkAction/hooks/useBulkActionNavigation'
import { PaginationBody } from '@Entities/pagination'

const WorkMergeSearch = () => {
    const { catalogSearchBulkActionStore, publicSearchWorksStore, rightsholderStore, workStore } =
        useContext(StoresContext)
    const navigate = useNavigate()

    const { blocker, bulkActionLabel } = useBulkActionNavigation(
        catalogSearchBulkActionStore,
        publicSearchWorksStore,
        bulkActionLabels
    )

    // Being on this page is the merge request, so works are selectable straight away
    useEffect(() => {
        workStore.destroyViewWork()
        catalogSearchBulkActionStore.setActiveBulkAction(WorkMergeBulkActionType.WorkMerge)
        return () => {
            catalogSearchBulkActionStore.resetStore()
        }
    }, [])

    // Ending the bulk action (backing out of it, or submitting the request) ends the merge request itself
    useEffect(() => {
        if (catalogSearchBulkActionStore.activeBulkAction === null) {
            navigate(Navigation.rightholder.workMerge.root(rightsholderStore.currentRightsholderId))
        }
    }, [catalogSearchBulkActionStore.activeBulkAction])

    const runSearch = (pagination?: PaginationBody) => publicSearchWorksStore.searchForWorks(pagination)

    return (
        <>
            <BulkActionLeavePageModal
                store={catalogSearchBulkActionStore}
                runSearch={runSearch}
                blocker={blocker}
                bulkActionLabel={bulkActionLabel}
            />
            <PublicSearchByWorkTab
                bulkActionControlSection={<WorkMergeBulkAction />}
                resultsOverride={catalogSearchBulkActionStore.isMergingWorks ? <WorkMergePanel /> : undefined}
                hideSearch={catalogSearchBulkActionStore.isReviewingRequest}
            />
        </>
    )
}

export default observer(WorkMergeSearch)
